// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gm58r","newExpiryDate":"styles_newExpiryDate__1E67Z","footer":"styles_footer__13H1A"};